<dp-main-view [config]="mainView" [showMenu]="true" (logout)="logout()"></dp-main-view>